// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { LocaleBetaProvider as BaseLocaleProvider } from '@plesk/ui-library';
import { Locale, Observer } from 'jsw';
import { useEventListener } from 'common/hooks';

const mergeMessages = (oldMessages, messages, prefix) => {
    const prefixedMessages = Object.entries(messages)
        .reduce((res, [key, value]) => {
            res[`${prefix}.${key}`] = value;
            return res;
        }, {});

    return {
        ...oldMessages,
        ...prefixedMessages,
    };
};

const LocaleProvider = ({ children = undefined }) => {
    const [messages, setMessages] = useState(Object.entries(Locale.sections)
        .reduce((oldMessages, [sectionName, section]) => mergeMessages(oldMessages, section.messages, sectionName), {}));

    const handleAddedLocaleSection = useCallback(({ name, messages }) => {
        setMessages(oldMessages => mergeMessages(oldMessages, messages, name));
    }, []);

    const handleAddedLocaleSections = useCallback(({ sections }) => {
        setMessages(oldMessages => Object.entries(sections).reduce((acc, [name, messages]) => mergeMessages(acc, messages, name), oldMessages));
    }, []);

    useEventListener('plesk:addedLocaleSection', handleAddedLocaleSection, Observer);
    useEventListener('plesk:addedLocaleSections', handleAddedLocaleSections, Observer);


    return (
        <BaseLocaleProvider messages={messages}>
            {children}
        </BaseLocaleProvider>
    );
};

LocaleProvider.propTypes = {
    children: PropTypes.any,
};

export default LocaleProvider;
